import { getShareData } from '@/api/system'
export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}
export const initWechatSDK = async () => {
  const url = window.location.href

  try {
    const res = await getShareData({ url })
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.data.appId, // 必填，公众号的唯一标识
      timestamp: res.data.timeStamp, // 必填，生成签名的时间戳
      nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
    })
    wx.ready(function () {
      let data = {
        title: '海洋知道', // 分享标题
        desc: '海洋知道课堂', // 分享描述
        link: url, // 该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://chasingstar.cn/miniProgramImg/oceanLogo.png' // 分享图标
      }
      wx.updateAppMessageShareData(data)
      wx.updateTimelineShareData(data)
    })
  } catch (error) {
    console.error('微信JS-SDK初始化失败', error)
  }
}

export const iosInitWechatSDK = async (data) => {
  const url = data
  try {
    // 获取签名
    const res = await getShareData({ url: sessionStorage.getItem('url') })
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.data.appId, // 必填，公众号的唯一标识
      timestamp: res.data.timeStamp, // 必填，生成签名的时间戳
      nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
    })
    wx.ready(function () {
      let data = {
        title: '海洋知道', // 分享标题
        desc: '海洋知道课堂', // 分享描述
        link: url, // 该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://chasingstar.cn/miniProgramImg/oceanLogo.png' // 分享图标
      }
      wx.updateAppMessageShareData(data)
      wx.updateTimelineShareData(data)
    })
  } catch (error) {
    console.error('微信JS-SDK初始化失败', error)
  }
}



// WEBPACK FOOTER //
// ./src/utils/wxShare.js